import React from "react";

const PaymentStatus = ({ status, error, planName, onRetry, onDone }) => {
  if (status === "success") {
    return (
      <div className="text-center py-5">
        {/* Success icon */}
        <div
          className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4"
          style={{
            width: 72,
            height: 72,
            background: "linear-gradient(135deg, #7F56D9 0%, #9E77ED 100%)",
          }}
        >
          <svg
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#FFFFFF"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>

        <h5 className="fw-bold mb-2" style={{ color: "#101828" }}>
          Subscription Active!
        </h5>
        <p className="text-muted small mb-1">
          You're now subscribed
          {planName ? (
            <>
              {" "}
              to{" "}
              <span className="fw-semibold" style={{ color: "#7F56D9" }}>
                {planName}
              </span>
            </>
          ) : null}
          .
        </p>
        <p className="text-muted small mb-4">
          A receipt will be emailed to you shortly.
        </p>

        <button
          className="btn px-5 py-2 fw-semibold rounded-pill"
          style={{
            background: "#7F56D9",
            color: "#FFFFFF",
            border: "none",
          }}
          onClick={onDone}
        >
          Done
        </button>
      </div>
    );
  }

  // Error state
  return (
    <div className="text-center py-5">
      {/* Error icon */}
      <div
        className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4"
        style={{
          width: 72,
          height: 72,
          background: "#FEF3F2",
          border: "2px solid #FDA29B",
        }}
      >
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#F04438"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      </div>

      <h5 className="fw-bold mb-2" style={{ color: "#101828" }}>
        Subscription Failed
      </h5>
      <p className="small text-muted mb-1">
        {error || "Something went wrong while processing your subscription."}
      </p>
      <p className="small text-muted mb-4">
        Please check your card details and try again.
      </p>

      <button
        className="btn px-5 py-2 fw-semibold rounded-pill"
        style={{
          background: "#7F56D9",
          color: "#FFFFFF",
          border: "none",
        }}
        onClick={onRetry}
      >
        Try Again
      </button>
    </div>
  );
};

export default PaymentStatus;
